import React from "react";
import { useNavigate, Link } from "react-router-dom";

function DashboardHeader({ onLogout }) {
    const navigate = useNavigate();
    const handleLogoutClick = () => {
        onLogout();
        navigate('/admin/login');

    }
    return (
        <nav className="dashboard-nav">
            <div className="logo">
                <a href="http://localhost:3000/">
                    <span className="fa fa-wordpress"></span>
                </a>
            </div>
            <ul className="main-nav">
                <li>
                    <Link to="/admin/dashboard">
                        <span className="fa fa-home"></span>
                        Dashboard
                    </Link>
                </li>
                <li>
                    <Link to="/admin/projects">
                        <span className="fa fa-home"></span>
                        Projects
                    </Link>
                </li>

                <li>
                    <Link to="/admin/fetured-projects">
                        <span className="fa fa-home"></span>
                        Featured Projects
                    </Link>
                </li>
                <li>
                    <Link to="/admin/category">
                        <span className="fa-solid fa-layer-group"></span>
                        Categories
                    </Link>
                </li>
                <li>
                    <Link to="/admin/category-projects">
                        <span className="fa fa-home"></span>
                        Category Projects
                    </Link>
                </li>



                <li>
                    <Link to="/admin/languages">
                        <span className="fa-solid fa-layer-group"></span>
                        Languages
                    </Link>
                </li>
                <li>
                    <Link to="/admin/portfolios">
                        <span className="fa fa-home"></span>
                        Portfolios
                    </Link>
                </li>

                <li>
                    <Link to="/admin/shareholders">
                        <span className="fa fa-home"></span>
                        Shareholders
                    </Link>
                </li>

                <li>
                    <Link to="/admin/blogs">
                        <span className="fa fa-home"></span>
                        Blogs
                    </Link>
                </li>

                <li>
                    <Link to="/admin/reviews">
                        <span className="fa fa-home"></span>
                        Reviews
                    </Link>
                </li>
                <li>
                    <Link to="/admin/services">
                        <span className="fa fa-home"></span>
                        Services
                    </Link>
                </li>
                <li>
                    <Link to="/admin/settings">
                        <span className="fa fa-home"></span>
                        Settings
                    </Link>
                </li>
                <li>
                    <Link to="/admin/home-page-banner">
                        <span className="fa fa-home"></span>
                        Home Page Banner
                    </Link>
                </li>

                <li>
                    <Link to="/admin/facade-page">
                        <span className="fa fa-home"></span>
                        Facade Page Content
                    </Link>
                </li>
                <li>
                    <Link to="/admin/contractor">
                        <span className="fa fa-home"></span>
                        Contractor Page
                    </Link>
                </li>
                <li>
                    <Link to="/admin/arch-design">
                        <span className="fa fa-home"></span>
                        Archtecture Page
                    </Link>
                </li>
                <li>
                    <a onClick={handleLogoutClick} className="logout-btn">
                        <span className="fa fa-sign-out"></span>
                        Logout
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default DashboardHeader;
